import React, { Component } from "react";
import styles from "./Calculator.scss";
import down from "./icons/green_chevron.png";
import up from "./icons/red_chevron.png";
import classnames from "classnames";

const hiddenTextBox = {
  opacity: "0",
  transition: "opacity ease 0.5s"
};

const visibleTextBox = {};

export default class ComparisonBox extends Component {
  constructor(props) {
    super(props);
    this.state = {
      difference: undefined,
      displayText: undefined,
      textBoxStyle: hiddenTextBox,
      showTable: false
    };
  }

  componentDidMount() {
    this.compare();
  }

  componentDidUpdate(prevProps) {
    if (this.props.cityData !== prevProps.cityData) {
      this.compare();
    }
  }

  displayText = () => {
    this.setState({
      pictureTextBoxStyle: hiddenTextBox,
      infoTextBoxStyle: visibleTextBox
    });
  };

  hideText = () => {
    this.setState({
      pictureTextBoxStyle: visibleTextBox,
      infoTextBoxStyle: hiddenTextBox
    });
  };

  renderResults = num => {
    if (num === 0) {
      return <b>{this.props.title} -- </b>;
    } else if (num < 0) {
      num = -1 * num;
      return (
        <b>
          {this.props.title} {"   "}
          <img alt={""} src={up} style={{ height: "20px", width: "20px" }} /> {num}%
        </b>
      );
    } else {
      return (
        <b>
          {this.props.title}
          {"   "}
          <img alt={""} src={down} style={{ height: "20px", width: "20px" }} />{" "}
          {num}%
        </b>
      );
    }
  };

  compare = () => {
    let kingstonData = this.props.kingstonData;
    let cityData = this.props.cityData;
    let difference = undefined;

    difference = ((cityData - kingstonData) / cityData) * 100;
    difference = Math.round(difference);

    let text = this.renderResults(difference);

    this.setState({
      difference: difference,
      displayText: text
    });
  };

  configureText = () => {
    let difference = this.state.difference;
    let text = "";

    if (difference === 0) {
      text = <p className={styles.calcText}> Your money goes just as far in Kingston!</p>;
    } else if (difference < 0) {
      difference = -1 * difference;
      text = <p className={styles.calcText}>Your money does not go as far in Kingston</p>;
    } else {
      text = <p className={styles.calcText}>Your money goes further in Kingston!</p>;
    }

    return text;
  };

  render() {
    if (this.props.mobile) {
      return (
        <div className={classnames("row",styles.comparisonBox)}>
          <div className="col-sm-6" style={{maxHeight: "50vh", minHeight: "30vh"}}>
            <h3>{this.state.displayText}</h3>
            {this.configureText()}
            {this.props.chart}
          </div>
        </div>
      )
    }
    else if (this.props.float === "left") {
      return (
        <div className={classnames("row",styles.comparisonBox)}>
          <div className="col-sm-6" style={{maxHeight: this.props.boxHeight, minHeight: this.props.boxHeight}}>
            {this.state.showTable ? (
              <div>{this.props.chart}</div>
            ) : (
              <img src={this.props.image} alt={this.props.title} />
            )}
          </div>
          <div className="col-sm-6">
            <h3>{this.state.displayText}</h3>

            {this.configureText()}
            <button id='bootstrap-btn'
              // className={styles.button}
              type="button"
              className="btn btn-secondary"
              onClick={() =>
                this.setState({ showTable: !this.state.showTable })
              }
            >
              {this.state.showTable
                ? "Hide information"
                : "See more information"}
            </button>
          </div>
        </div>
      );
    } else {
      return (
        <div className={classnames("row",styles.comparisonBox)}>
          <div className="col-sm-6" >
            <h3>{this.state.displayText}</h3>

            {this.configureText()}
            <button id="bootstrap-btn"
              // className={styles.button}
              type="button"
              className="btn btn-secondary"
              onClick={() =>
                this.setState({ showTable: !this.state.showTable })
              }
            >
              {this.state.showTable
                ? "Hide information"
                : "See more information"}
            </button>
          </div>
          <div className="col-sm-6" style={{maxHeight: this.props.boxHeight, minHeight: this.props.boxHeight}}>
            {this.state.showTable ? (
              <div>{this.props.chart}</div>
            ) : (
              <img src={this.props.image} alt={this.props.title} />
            )}
          </div>
        </div>
      );
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/Calculator/ComparisonBox.js